class AnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.initialMessage = this.dataset.initialMessage;
    this.awayMessage = this.dataset.awayMessage;
    this.finalMessage = this.dataset.finalMessage;
    this.freeShippingThreshold = parseFloat(this.dataset.freeShippingThreshold) * 100;
  }

  waitForConstants(callback) {
    if (typeof PUB_SUB_EVENTS !== 'undefined' && window.Shopify?.pubsub) {
      callback();
    } else {
      setTimeout(() => this.waitForConstants(callback), 50);
    }
  }

  connectedCallback() {
    this.update(); // Initial update on page load.

    // Subscribe to cart updates for real-time changes.
    this.waitForConstants(() => {
      // The update function is now just a trigger, it doesn't need the event data.
      Shopify.pubsub.subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.update());
    });

    // Add resiliency listeners.
    window.addEventListener('pageshow', () => this.update());
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') this.update();
    });
  }

  /**
   * Main update handler. Always fetches the latest cart data from Shopify's
   * canonical endpoint to ensure data is always complete and correct.
   */
  update() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartTotal = cart.total_price || 0;
        let message = '';

        if (cartTotal >= this.freeShippingThreshold) {
          message = this.finalMessage;
        } else if (cartTotal > 0) {
          const amountAway = this.freeShippingThreshold - cartTotal;
          const formattedAmount = this._formatMoney(amountAway);
          const styledAmount = formattedAmount.replace(/([0-9.,]+)₺/, '<span class="away_money">$1<span class="currency-indicator">₺</span></span>');
          message = this.awayMessage.replace('*money*', styledAmount);
        } else {
          message = this.initialMessage;
        }

        this.innerHTML = message;
        this.classList.add('is-initialized');
      })
      .catch(error => {
        console.error('Error updating announcement bar:', error);
        this.innerHTML = this.initialMessage; // Fallback to initial message
        this.classList.add('is-initialized');
      });
  }

  /**
   * Refined money formatting for better predictability.
   * @param {number} kurus - The amount in Kuruş.
   * @returns {string} - The formatted string, e.g., "750,00₺".
   */
  _formatMoney(kurus) {
    if (typeof kurus !== 'number') {
      kurus = parseInt(kurus || '0', 10);
    }
    // Get only the formatted number, which is more predictable for regex.
    const amount = (kurus / 100.0).toLocaleString('tr-TR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
    // Append the currency symbol without space for format like "750,00₺"
    return `${amount}₺`;
  }
}

customElements.define('announcement-bar', AnnouncementBar);